<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="分类:">
            <el-select v-model="obj.block" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.blockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业:">
            <el-select v-model="obj.selectedIndustryValue" @change="handleSelectChange" style="width:180px">
              <el-option v-for="item in obj.selectIndustryList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指数:">
            <el-select v-model="obj.selectedIndexValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectIndexList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区:">
            <el-select v-model="obj.selectedDistrictValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectDistrictList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="期间:">
            <el-select v-model="obj.day" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.dayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="信号级别:">
            <el-select v-model="obj.interval" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.intervalList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信号多空:">
            <el-select v-model="obj.trend" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.trendList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信号强度:">
            <el-select v-model="obj.level" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.level_List" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="开平仓条件:">
            <el-select v-model="obj.operationLevel" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.operationLevel_list" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <cpu />
              </el-icon>筛选
            </el-button>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleReset">
              <el-icon class="el-input__icon">
                <refresh />重置
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <div>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">更新日： {{ obj.date }}</el-tag>
    </div>
    <div>
      <!-- <el-tag type="warning" size="small">最新信号</el-tag> -->
    </div>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) / 1 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick2" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="120px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="90px" align="right" />
        <el-table-column label="涨幅%" prop="chgPct" width="100px" align="right" :sort-method="customPctSort" sortable />
        <el-table-column label="板块" prop="industry" width="120px" align="right" sortable />
        <el-table-column label="多头信号" prop="signal_long" width="430px" align="left" />
        <el-table-column label="信号强度" prop="signal_long_lv" width="105px" align="left" sortable />
        <el-table-column label="空头信号" prop="signal_short" width="430px" align="left" />
        <el-table-column label="信号强度" prop="signal_short_lv" width="105px" align="left" sortable />
        <!-- <el-table-column label="开平仓" prop="" width="80px" align="left">
          <template #default="scope">
            <el-button v-if="scope.row.open_close == '1' && scope.row.direction == '1'" size="small" type="danger"
              @click.stop="handleOperation(scope.$index, scope.row)">开仓</el-button>
            <el-button v-if="scope.row.open_close == '1' && scope.row.direction == '0'" size="small" type="success"
              @click.stop="handleOperation(scope.$index, scope.row)">空开</el-button>
            <el-button v-if="scope.row.open_close == '0' && scope.row.direction == '1'" size="small" type="primary"
              @click.stop="handleOperation(scope.$index, scope.row)">多平</el-button>
            <el-button v-if="scope.row.open_close == '0' && scope.row.direction == '0'" size="small" type="primary"
              @click.stop="handleOperation(scope.$index, scope.row)">平仓</el-button>
            <span v-if="scope.row.holding == '1'">持仓中</span>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination background layout="prev, pager, next" :page-size="obj.limit" :total="obj.total"
        :current-page="obj.page" class="mt-16 mb-16" @current-change="handlePageChange"></el-pagination>
    </div>
    <div>
      <!-- <el-tag type="warning" size="small">信号详细</el-tag> -->
    </div>
    <!-- <div>
      <el-table :data="obj.dataList2" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 280) / 2 + 'px'" :cell-style="cellStyle2"
        @row-click="handleRowClick2" highlight-current-row>
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="日期" prop="date" width="110px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="110px" align="right" />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chgPct" width="100px" align="right" />
        <el-table-column label="上穿MA5(日)" prop="MA5_CROSSUP" width="110px" align="right" />
        <el-table-column label="大阳(日)" prop="BIG_UP" width="100px" align="right" />
        <el-table-column label="底背离(日)" prop="short_divergence" width="100px" align="right" />
        <el-table-column label="上穿MA5(周)" prop="W_MA5_CROSSUP" width="110px" align="right" />
        <el-table-column label="板块上穿MA5(日)" prop="I_MA5_CROSSUP" width="140px" align="right" />
        <el-table-column label="下穿MA5(日)" prop="MA5_CROSSDOWN" width="110px" align="right" />
        <el-table-column label="大阴(日)" prop="BIG_DOWN" width="100px" align="right" />
        <el-table-column label="顶背离(日)" prop="long_divergence" width="100px" align="right" />
        <el-table-column label="下穿MA5(周)" prop="W_MA5_CROSSDOWN" width="110px" align="right" />
        <el-table-column label="板块下穿MA5(日)" prop="I_MA5_CROSSDOWN" width="140px" align="right" />
        <el-table-column label="开平仓信号" prop="operation" width="100px" align="right" />
        <el-table-column label="平仓收益" prop="profit" width="100px" align="right" />
      </el-table>
    </div> -->
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
import { nextTick } from "vue"
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const singleTableRef = ref()
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      total: 0,
      page: 1,
      limit: 50,
      blockList: [
        {
          value: 'favorites',
          label: '自选'
        },
        {
          value: 'all',
          label: '全部A股'
        },
        {
          value: 'shse',
          label: '上证A股'
        },
        {
          value: 'szse',
          label: '深证A股'
        },
        {
          value: 'bse',
          label: '北证A股'
        },
        {
          value: 'shse_zb',
          label: '上证主板'
        },
        {
          value: 'szse_zb',
          label: '深证主板'
        },
        {
          value: 'shse_kcb',
          label: '科创版'
        },
        {
          value: 'szse_cyb',
          label: '创业版'
        },
      ],
      block: 'all',
      selectIndexList: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 'hs300',
          label: '沪深300'
        },
        {
          value: 'sz50',
          label: '上证50'
        },
        {
          value: 'zz500',
          label: '中证500'
        },
        {
          value: 'zz1000',
          label: '中证1000'
        },
        {
          value: 'cy300',
          label: '创业300'
        },
        {
          value: 'kc50',
          label: '科创50'
        },
        {
          value: 'bz50',
          label: '北证50'
        },
      ],
      selectedIndexValue: 'all',
      selectIndustryList: [
        { 'value': 'all', 'label': '全部' },
        { 'value': '煤炭开采', 'label': '1002 煤炭开采' },
        { 'value': '焦炭加工', 'label': '1005 焦炭加工' },
        { 'value': '油气开采', 'label': '1007 油气开采' },
        { 'value': '石油化工', 'label': '1011 石油化工' },
        { 'value': '油服工程', 'label': '1008 油服工程' },
        { 'value': '日用化工', 'label': '1016 日用化工' },
        { 'value': '化纤', 'label': '1019 化纤' },
        { 'value': '化学原料', 'label': '1026 化学原料' },
        { 'value': '化学制品', 'label': '1034 化学制品' },
        { 'value': '塑料', 'label': '1044 塑料' },
        { 'value': '橡胶', 'label': '1051 橡胶' },
        { 'value': '农用化工', 'label': '1055 农用化工' },
        { 'value': '非金属材料', 'label': '1104 非金属材料' },
        { 'value': '冶钢原料', 'label': '1062 冶钢原料' },
        { 'value': '普钢', 'label': '1065 普钢' },
        { 'value': '特钢', 'label': '1069 特钢' },
        { 'value': '工业金属', 'label': '1071 工业金属' },
        { 'value': '贵金属', 'label': '1075 贵金属' },
        { 'value': '能源金属', 'label': '1078 能源金属' },
        { 'value': '稀有金属', 'label': '1082 稀有金属' },
        { 'value': '金属新材料', 'label': '1087 金属新材料' },
        { 'value': '水泥', 'label': '1091 水泥' },
        { 'value': '玻璃玻纤', 'label': '1094 玻璃玻纤' },
        { 'value': '装饰建材', 'label': '1097 装饰建材' },
        { 'value': '种植业', 'label': '1106 种植业' },
        { 'value': '养殖业', 'label': '1111 养殖业' },
        { 'value': '林业', 'label': '1115 林业' },
        { 'value': '渔业', 'label': '1116 渔业' },
        { 'value': '饲料', 'label': '1119 饲料' },
        { 'value': '农产品加工', 'label': '1123 农产品加工' },
        { 'value': '动物保健', 'label': '1127 动物保健' },
        { 'value': '酿酒', 'label': '1130 酿酒' },
        { 'value': '饮料乳品', 'label': '1136 饮料乳品' },
        { 'value': '调味品', 'label': '1139 调味品' },
        { 'value': '休闲食品', 'label': '1140 休闲食品' },
        { 'value': '食品加工', 'label': '1144 食品加工' },
        { 'value': '纺织制造', 'label': '1151 纺织制造' },
        { 'value': '服装家纺', 'label': '1157 服装家纺' },
        { 'value': '饰品', 'label': '1162 饰品' },
        { 'value': '造纸', 'label': '1167 造纸' },
        { 'value': '包装印刷', 'label': '1171 包装印刷' },
        { 'value': '家居用品', 'label': '1177 家居用品' },
        { 'value': '文娱用品', 'label': '1180 文娱用品' },
        { 'value': '白色家电', 'label': '1184 白色家电' },
        { 'value': '黑色家电', 'label': '1187 黑色家电' },
        { 'value': '小家电', 'label': '1190 小家电' },
        { 'value': '厨卫电器', 'label': '1194 厨卫电器' },
        { 'value': '家电零部件', 'label': '1198 家电零部件' },
        { 'value': '一般零售', 'label': '1200 一般零售' },
        { 'value': '商业物业经营', 'label': '1204 商业物业经营' },
        { 'value': '专业连锁', 'label': '1205 专业连锁' },
        { 'value': '贸易', 'label': '1206 贸易' },
        { 'value': '电子商务', 'label': '1207 电子商务' },
        { 'value': '乘用车', 'label': '1212 乘用车' },
        { 'value': '商用车', 'label': '1215 商用车' },
        { 'value': '汽车零部件', 'label': '1218 汽车零部件' },
        { 'value': '汽车服务', 'label': '1224 汽车服务' },
        { 'value': '摩托车及其他', 'label': '1227 摩托车及其他' },
        { 'value': '化学制药', 'label': '1231 化学制药' },
        { 'value': '生物制品', 'label': '1234 生物制品' },
        { 'value': '中药', 'label': '1256 中药' },
        { 'value': '医药商业', 'label': '1252 医药商业' },
        { 'value': '医疗器械', 'label': '1241 医疗器械' },
        { 'value': '医疗服务', 'label': '1247 医疗服务' },
        { 'value': '医疗美容', 'label': '1257 医疗美容' },
        { 'value': '电机制造', 'label': '1261 电机制造' },
        { 'value': '电池', 'label': '1262 电池' },
        { 'value': '电网设备', 'label': '1268 电网设备' },
        { 'value': '光伏设备', 'label': '1275 光伏设备' },
        { 'value': '风电设备', 'label': '1282 风电设备' },
        { 'value': '其他发电设备', 'label': '1285 其他发电设备' },
        { 'value': '地面兵装', 'label': '1287 地面兵装' },
        { 'value': '航空装备', 'label': '1288 航空装备' },
        { 'value': '航天装备', 'label': '1289 航天装备' },
        { 'value': '航海装备', 'label': '1290 航海装备' },
        { 'value': '军工电子', 'label': '1291 军工电子' },
        { 'value': '轨交设备', 'label': '1293 轨交设备' },
        { 'value': '通用设备', 'label': '1294 通用设备' },
        { 'value': '专用设备', 'label': '1303 专用设备' },
        { 'value': '工程机械', 'label': '1310 工程机械' },
        { 'value': '自动化设备', 'label': '1313 自动化设备' },
        { 'value': '半导体', 'label': '1319 半导体' },
        { 'value': '消费电子', 'label': '1326 消费电子' },
        { 'value': '光学光电', 'label': '1329 光学光电' },
        { 'value': '元器件', 'label': '1333 元器件' },
        { 'value': '其他电子', 'label': '1336 其他电子' },
        { 'value': '通信设备', 'label': '1338 通信设备' },
        { 'value': '通信工程', 'label': '1347 通信工程' },
        { 'value': '电信服务', 'label': '1344 电信服务' },
        { 'value': 'IT设备', 'label': '1352 IT设备' },
        { 'value': '软件服务', 'label': '1355 软件服务' },
        { 'value': '云服务', 'label': '1359 云服务' },
        { 'value': '产业互联网', 'label': '1364 产业互联网' },
        { 'value': '游戏', 'label': '1369 游戏' },
        { 'value': '广告营销', 'label': '1370 广告营销' },
        { 'value': '影视院线', 'label': '1373 影视院线' },
        { 'value': '数字媒体', 'label': '1376 数字媒体' },
        { 'value': '出版业', 'label': '1380 出版业' },
        { 'value': '广播电视', 'label': '1384 广播电视' },
        { 'value': '全国性银行', 'label': '1386 全国性银行' },
        { 'value': '地方性银行', 'label': '1389 地方性银行' },
        { 'value': '证券', 'label': '1394 证券' },
        { 'value': '保险', 'label': '1395 保险' },
        { 'value': '多元金融', 'label': '1396 多元金融' },
        { 'value': '房屋建设', 'label': '1406 房屋建设' },
        { 'value': '基础建设', 'label': '1407 基础建设' },
        { 'value': '专业工程', 'label': '1410 专业工程' },
        { 'value': '工程咨询服务', 'label': '1415 工程咨询服务' },
        { 'value': '装修装饰', 'label': '1416 装修装饰' },
        { 'value': '房地产开发', 'label': '1418 房地产开发' },
        { 'value': '房产服务', 'label': '1422 房产服务' },
        { 'value': '体育', 'label': '1427 体育' },
        { 'value': '教育培训', 'label': '1428 教育培训' },
        { 'value': '酒店餐饮', 'label': '1429 酒店餐饮' },
        { 'value': '旅游', 'label': '1432 旅游' },
        { 'value': '专业服务', 'label': '1436 专业服务' },
        { 'value': '公路铁路', 'label': '1442 公路铁路' },
        { 'value': '航空机场', 'label': '1446 航空机场' },
        { 'value': '航运港口', 'label': '1449 航运港口' },
        { 'value': '物流', 'label': '1452 物流' },
        { 'value': '电力', 'label': '1459 电力' },
        { 'value': '燃气', 'label': '1467 燃气' },
        { 'value': '水务', 'label': '1468 水务' },
        { 'value': '环保设备', 'label': '1470 环保设备' },
        { 'value': '环境治理', 'label': '1471 环境治理' },
        { 'value': '环境监测', 'label': '1476 环境监测' },
        { 'value': '综合类', 'label': '1478 综合类' }
      ],
      selectedIndustryValue: 'all',
      selectDistrictList: [  
        {  
          value: 'all',  
          label: '全部'  
        },  
        {  
          value: '北京',  
          label: '北京'  
        },  
        {  
          value: '上海',  
          label: '上海'  
        },  
        {  
          value: '广东',  
          label: '广东'
        },  
        {  
          value: '深圳',  
          label: '深圳'  
        },  
        {  
          value: '重庆',  
          label: '重庆'  
        },  
        {  
          value: '江苏',  
          label: '江苏'
        },  
        {  
          value: '浙江',  
          label: '浙江'
        },  
        {  
          value: '山东',  
          label: '山东'
        },  
        {  
          value: '天津',  
          label: '天津'  
        },  
        {  
          value: '湖北',  
          label: '湖北'
        },  
        {  
          value: '四川',  
          label: '四川'
        },  
        {  
          value: '陕西',  
          label: '陕西'
        },  
        {  
          value: '福建',  
          label: '福建'
        }, 
        {  
          value: '辽宁',  
          label: '辽宁'
        },  
        {  
          value: '黑龙江',  
          label: '黑龙江'  
        },  
        {  
          value: '新疆',  
          label: '新疆'  
        },  
        {  
          value: '吉林',  
          label: '吉林'  
        },  
        {  
          value: '甘肃',  
          label: '甘肃'  
        },  
        {  
          value: '青海',  
          label: '青海'  
        },  
        {  
          value: '广西',  
          label: '广西'  
        },  
        {  
          value: '河北',  
          label: '河北'  
        },  
        {  
          value: '河南',  
          label: '河南'  
        },  
        {  
          value: '宁夏',  
          label: '宁夏'  
        },  
        {  
          value: '山西',  
          label: '山西'  
        },  
        {  
          value: '湖南',  
          label: '湖南'  
        },  
        {  
          value: '江西',  
          label: '江西'  
        },  
        {  
          value: '安徽',  
          label: '安徽'  
        },  
        {  
          value: '云南',  
          label: '云南'  
        },  
        {  
          value: '贵州',  
          label: '贵州'  
        },  
        {  
          value: '海南',  
          label: '海南'  
        },  
        {  
          value: '西藏',  
          label: '西藏'  
        },  
        {  
          value: '内蒙',  
          label: '内蒙'  
        },
      ],
      selectedDistrictValue: 'all',
      dayList: [
        {
          value: '1',
          label: '最近 1日'
        },
        {
          value: '2',
          label: '最近 2日'
        },
        {
          value: '3',
          label: '最近 3日'
        },
        {
          value: '4',
          label: '最近 4日'
        },
        {
          value: '5',
          label: '最近 5日'
        },
        // {
        //   value: '10',
        //   label: '最近 10日'
        // },
        // {
        //   value: '20',
        //   label: '最近 20日'
        // },
      ],
      day: '1',
      intervalList: [
        {
          value: '1',
          label: '日线'
        },
        {
          value: '2',
          label: '1小时线'
        },
        {
          value: '3',
          label: '15分钟线'
        },
      ],
      interval: '1',
      trendList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'Long',
          label: '多头'
        },
        {
          value: 'Short',
          label: '空头'
        },
      ],
      trend: '',
      level_List: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '1级'
        },
        {
          value: '2',
          label: '2级'
        },
        {
          value: '3',
          label: '3级'
        },
        {
          value: '4',
          label: '4级'
        },
        {
          value: '5',
          label: '5级'
        },
        {
          value: '6',
          label: '6级'
        },
      ],
      level: '',
      operationLevel_list: [
        {
          value: '3',
          label: '3级以上'
        },
        {
          value: '4',
          label: '4级以上'
        },
        {
          value: '5',
          label: '5级以上'
        },
      ],
      operationLevel: '5',
      dataList: [],
      dataList2: [],
      date: '',
      selected: '',
      selectedValue: '',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.signalData === '') {
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let block = obj.block
      if (obj.selectedIndexValue != "all") {
        block = block + "," + obj.selectedIndexValue
      }
      if (obj.selectedIndustryValue != "all") {
        block = block + "," + obj.selectedIndustryValue
      }
      if (obj.selectedDistrictValue != "all") {
        block = block + "," + obj.selectedDistrictValue
      }

      let formData = new FormData()
      formData.append("block", block)
      formData.append("day", obj.day)
      formData.append("interval", obj.interval)
      formData.append("trend", obj.trend)
      formData.append("level", obj.level)
      formData.append("operationLevel", obj.operationLevel)
      formData.append("page", obj.page)
      formData.append("limit", obj.limit)
      http({
        url: `/signal`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        processData(res.data.data)
        setStore()
        // console.log(singleTableRef)
        singleTableRef.value.clearSort() // 清空表格排序状态
        singleTableRef.value.setScrollTop(0) // 表格滚动条返回最上方
        // nextTick(() => {
        //   singleTableRef.value.setScrollTop(0)
        // })

        // 如果选择的合约在重新刷新后的最新信号一览(obj.dataList)内才执行requestData2
        if (obj.selected != "") {
          let flag = false
          for (let x of obj.dataList) {
            if (x.name === obj.selected) {
              flag = true
              break
            }
          }
          if (flag) {
            requestData2(obj.selected)
          } else {
            obj.dataList2 = []
            obj.selected = ""
            obj.selectedValue = ""
          }

        }
      })
    }

    // 后台获取数据2
    const requestData2 = (name) => {
      let formData = new FormData()
      formData.append("name", name)
      formData.append("block", obj.block)
      formData.append("day", obj.day)
      formData.append("operationLevel", obj.operationLevel)
      formData.append("page", 1)
      formData.append("limit", 20)
      http({
        url: `/signal`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        processData2(res.data.data)
        setStore()
      })
    }

    // const setCurrent = (row) => {
    //   singleTableRef.value.setCurrentRow(row)
    // }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
        }
        item.no = no
        no++
      })
      obj.total = data.total
      obj.dataList = data.data
    }

    // 处理数据
    const processData2 = (data) => {
      let no = 1
      data.data.forEach((item) => {
        if (item.chgPct !== "-") {
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
        }
        if (item.profit != "-") {
          item.profit = parseFloat(item.profit * 100).toFixed(2) + '%'
        }
        item.no = no
        no++
      })
      obj.dataList2 = data.data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'block': obj.block,
        'selectedIndexValue': obj.selectedIndexValue,
        'selectedIndustryValue': obj.selectedIndustryValue,
        'selectedDistrictValue': obj.selectedDistrictValue,
        'day': obj.day,
        'interval': obj.interval,
        'trend': obj.trend,
        'level': obj.level,
        'operationLevel': obj.operationLevel,
        'dataList': obj.dataList,
        'dataList2': obj.dataList2,
        'date': obj.date,
        'selected': obj.selected,
        'selectedValue': obj.selectedValue,
        'total': obj.total,
        'page': obj.page,
      }
      store.commit('setSignalData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.block = store.state.signalData.block
      obj.selectedIndexValue = store.state.signalData.selectedIndexValue
      obj.selectedIndustryValue = store.state.signalData.selectedIndustryValue
      obj.selectedDistrictValue = store.state.signalData.selectedDistrictValue
      obj.day = store.state.signalData.day
      obj.interval = store.state.signalData.interval
      obj.trend = store.state.signalData.trend
      obj.level = store.state.signalData.level
      obj.operationLevel = store.state.signalData.operationLevel
      obj.dataList = store.state.signalData.dataList
      obj.dataList2 = store.state.signalData.dataList2
      obj.date = store.state.signalData.date
      obj.selected = store.state.signalData.selected
      obj.selectedValue = store.state.signalData.selectedValue
      obj.total = store.state.signalData.total
      obj.page = store.state.signalData.page
    }

    // 重置画面
    const resetView = () => {
      obj.block = 'all'
      obj.selectedIndexValue = 'all'
      obj.selectedIndustryValue = 'all'
      obj.selectedDistrictValue = 'all'
      obj.day = 1
      obj.interval = '1'
      obj.trend = ''
      obj.level = ''
      obj.operationLevel = '5'
      obj.dataList = []
      obj.dataList = ''
      obj.dataList2 = []
      obj.dataList2 = ''
      obj.date = ''
      obj.selected = ''
      obj.selectedValue = ''
      obj.total = 0
      obj.page = 1
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      obj.total = 0
      obj.page = 1
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      obj.total = 0
      obj.page = 1
      requestData()
    }

    // 按钮重置事件
    const handleReset = (e) => {
      resetView()
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      obj.selected = row.name
      obj.selectedValue = row.symbol
      requestData2(obj.selected)
    }

    // 表格行点击事件2
    const handleRowClick2 = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      // if (!formCheck()) {
      //   return
      // }
      obj.selected = ""
      obj.selectedValue = ""
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    // 开平仓
    const handleOperation = (index, row) => {
      // console.log(index, row)
      let formData = new FormData()
      formData.append("name", row.name)
      formData.append("open_close", row.open_close)
      formData.append("direction", row.direction)
      formData.append("quantity", row.quantity)
      formData.append("price", row.close)
      http({
        url: `/trade`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success('操作成功')
        row.open_close = -1
        row.direction = -1
        row.quantity = -1
        // vueEvent.emit('updateBalanceEvent')
      })
    }

    // 分页变化事件
    const handlePageChange = (value) => {
      obj.page = value
      requestData()
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.signal_long.toString() != "" && row.columnIndex === 6) {
        return { color: 'red' }
      }
      if (row.row.signal_long_lv.toString() != 0 && row.columnIndex === 7) {
        return { color: 'red' }
      }
      if (row.row.signal_short.toString() != "" && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.signal_short_lv.toString() != 0 && row.columnIndex === 9) {
        return { color: 'green' }
      }
    }

    // 表格单元格样式2
    const cellStyle2 = (row, column, rowIndex, columnIndex) => {
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }

      if (row.row.MA5_CROSSUP == 1 && row.columnIndex === 6) {
        return { color: 'red' }
      }
      if (row.row.BIG_UP == 1 && row.columnIndex === 7) {
        return { color: 'red' }
      }
      if (row.row.short_divergence == 1 && row.columnIndex === 8) {
        return { color: 'red' }
      }
      if (row.row.W_MA5_CROSSUP == 1 && row.columnIndex === 9) {
        return { color: 'red' }
      }
      if (row.row.I_MA5_CROSSUP == 1 && row.columnIndex === 10) {
        return { color: 'red' }
      }

      if (row.row.MA5_CROSSDOWN == 1 && row.columnIndex === 11) {
        return { color: 'green' }
      }
      if (row.row.BIG_DOWN == 1 && row.columnIndex === 12) {
        return { color: 'green' }
      }
      if (row.row.long_divergence == 1 && row.columnIndex === 13) {
        return { color: 'green' }
      }
      if (row.row.W_MA5_CROSSDOWN == 1 && row.columnIndex === 14) {
        return { color: 'green' }
      }
      if (row.row.I_MA5_CROSSDOWN == 1 && row.columnIndex === 15) {
        return { color: 'green' }
      }

      if ((row.row.operation == "多开" || row.row.operation == "空平") && row.columnIndex === 16) {
        return { color: 'red' }
      } else if ((row.row.operation == "空开" || row.row.operation == "多平") && row.columnIndex === 16) {
        return { color: 'green' }
      }
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    return {
      obj,
      singleTableRef,
      chartDomRef,
      store,
      handleSelectChange,
      handleRefresh,
      handleReset,
      handleRowClick,
      handleRowClick2,
      handleSubmit,
      handleOperation,
      cellStyle,
      cellStyle2,
      customPctSort,
      handlePageChange,
    }
  }
}
</script>
<style lang="scss" scoped></style>
